__turbopack_context__.v({
  "name": "ypby_W_name",
  "tab": "ypby_W_tab",
  "tabFirst": "ypby_W_tabFirst",
  "tabLast": "ypby_W_tabLast",
  "tabMiddle": "ypby_W_tabMiddle",
  "tabNextSelected": "ypby_W_tabNextSelected",
  "tabNoBorderRight": "ypby_W_tabNoBorderRight",
  "tabPrevSelected": "ypby_W_tabPrevSelected",
  "tabSelected": "ypby_W_tabSelected",
  "tabWithBorderRight": "ypby_W_tabWithBorderRight",
  "tabsList": "ypby_W_tabsList",
  "tabsRoot": "ypby_W_tabsRoot",
});
